import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_CARD_CONFIG } from '@angular/material/card';
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
    PreloadAllModules,
    provideRouter,
    withInMemoryScrolling,
    withPreloading,
} from '@angular/router';
import { apiEndpointInterceptor } from './@core/http/interceptors/api-end-point.interceptor';
import { headerCompanyIdInterceptor } from './@core/http/interceptors/app-company-id.interceptor';
import { headerInterceptor } from './@core/http/interceptors/app-header.interceptor';
import { authInterceptor } from './@core/http/interceptors/auth-token.interceptor';
import { errorInterceptor } from './@core/http/interceptors/error-handler.interceptor';
import { appRoutes } from './app.routes';
import { appInitializer } from './appInitializer';
import { CustomDateAdapter } from './shared/adapters/custom-date.adapter';

export const appConfig: ApplicationConfig = {
    providers: [
        provideHttpClient(
            withInterceptors([
                errorInterceptor,
                apiEndpointInterceptor,
                authInterceptor,
                headerInterceptor,
                headerCompanyIdInterceptor,
            ]),
        ),
        provideAnimations(),
        provideRouter(
            appRoutes,
            withPreloading(PreloadAllModules),
            withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
        ),
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializer,
            multi: true,
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                floatLabel: 'always',
                appearance: 'outline',
                subscriptSizing: 'dynamic',
            },
        },
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'en-US',
        },
        {
            provide: DateAdapter,
            useClass: CustomDateAdapter,
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'MM/DD/YYYY',
                },
                display: {
                    dateInput: 'MM/DD/YYYY',
                    monthYearLabel: 'LLL yyyy',
                    dateA11yLabel: 'DD',
                    monthYearA11yLabel: 'LLLL yyyy',
                },
            },
        },
        {
            provide: MAT_ICON_DEFAULT_OPTIONS,
            useValue: { fontSet: 'material-symbols-outlined' },
        },
        {
            provide: MAT_CARD_CONFIG,
            useValue: { appearance: 'outlined' },
        },
        {
            provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
            useValue: { useUtc: true },
        },
    ],
};
